import type { FC, PropsWithChildren, Ref } from 'react';
import { useRef } from 'react';
import { classNames } from '../../utils/tailwind/classNames';
import { Footer } from '../footer';
import { Header } from '../header';

type LayoutProps = PropsWithChildren<{
    headerRef?: Ref<HTMLElement>;
    className?: string;
    stickyNavigation?: boolean;
}>;

export const Layout: FC<LayoutProps> = ({
    headerRef,
    children,
    className,
    stickyNavigation = true,
}) => {
    const ref = useRef<HTMLDivElement | null>(null);

    return (
        <>
            <Header headerRef={headerRef ?? ref} stickyNavigation={stickyNavigation} />
            <div className={classNames('h-full w-full', className)}>{children}</div>
            <Footer />
        </>
    );
};

Layout.defaultProps = {
    headerRef: undefined,
    className: undefined,
    stickyNavigation: true,
};
